import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../utils/apiServices";

export const getHomeFacts = createAsyncThunk(
  "homeFacts/fetchHomeFacts",
  async () => {
    // setAuthorizationToken(true);
    const response = await getMethod(`/api/homeFacts`);
    return response;
  }
);

const initialState = {
  loading: false,
  success: false,
  error: false,
  homeFacts: null,
};

const homeFactsSlice = createSlice({
  name: "homeFacts",
  initialState,
  // reducers: {
  //   isLoading: (state) => {
  //     state.loading = true;
  //     state.success = false;
  //     state.error = false;
  //   },
  //   isSuccess: (state, action) => {
  //     state.loading = false;
  //     state.success = true;
  //     state.error = false;
  //     state.homeFacts = action.payload;
  //   },
  //   isError: (state) => {
  //     state.loading = false;
  //     state.success = false;
  //     state.error = true;
  //   },
  // },

  extraReducers: (builder) => {
    builder.addCase(getHomeFacts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHomeFacts.fulfilled, (state, action) => {
      state.loading = false;
      state.homeFacts = action.payload.data;
    });
    builder.addCase(getHomeFacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

// export const { isLoading, isSuccess, isError } = homeFactsSlice.actions;

export default homeFactsSlice.reducer;

// export const getHomeFacts = () => async (dispatch) => {
//   try {
//     dispatch(isLoading);
//     const response = await getMethod(`/api/homeFacts`);
//     dispatch(isSuccess(response?.data));
//   } catch (error) {
//     dispatch(isError);
//   }
// };
